import { ReactNode, useState } from 'react';

import { StyledAutocomplete } from '../index.js';
import { StyledAutocompleteProps } from '../styled-autocomplete/styled-autocomplete.js';

interface OwnProps {
    label: ReactNode;
    validateValue?: (value: string) => boolean;
    delimiters?: string[];
    options?: (string | { label: string; value: string })[];
}

type Props = Omit<StyledAutocompleteProps<any>, 'renderInput' | 'inputValue' | 'onInputChange' | 'options'> & OwnProps;

const StyledChipInput: FC<Props> = ({
    label,
    validateValue,
    value,
    onChange,
    options = [],
    delimiters = [' ', ','],
    freeSolo = true,
    ...props
}) => {
    const [inputValue, setInputValue] = useState('');

    const createChip = (val) => {
        if (!validateValue || validateValue(val)) {
            onChange(null, [...value, val], 'createOption');
            setInputValue('');
        }
    };

    const onInputChange = (event: any, val: string, reason: string) => {
        if (freeSolo && reason === 'input' && delimiters.some((del) => val.endsWith(del))) {
            createChip(val.slice(0, -1));
        } else {
            setInputValue(val);
        }
    };

    const onBlur = () => {
        if (freeSolo && inputValue) {
            createChip(inputValue);
        }
    };

    return (
        <StyledAutocomplete
            freeSolo={freeSolo}
            multiple
            label={label}
            options={options}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            inputValue={inputValue}
            limitTags={10}
            onInputChange={onInputChange}
            {...props}
        />
    );
};

export default StyledChipInput;
